export interface ConfirmationAddressInterfaceState {
  visibility: boolean;
}

export const initialConfirmationAddressState: ConfirmationAddressInterfaceState = {
  visibility: null
};
